import { render, staticRenderFns } from "./bk.vue?vue&type=template&id=d1cfe596&scoped=true"
import script from "./bk.vue?vue&type=script&lang=js"
export * from "./bk.vue?vue&type=script&lang=js"
import style0 from "./bk.vue?vue&type=style&index=0&id=d1cfe596&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cfe596",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bk.vue
// module id = S7xU
// module chunks = 0